import { Footer as FooterComponent } from "@/components/Footer";

export function Footer() {
  return <FooterComponent />;
}